import React from 'react'

const Showcase = () => (
  <section className="vt-section showcase">
    <div className="vt-shell">
      <div className="sec-head">
        <span className="eyebrow">La prescription</span>
        <h2>Le document que votre client garde sur le frigo.</h2>
        <p>Un PDF clair, professionnel, avec les quantités, les repères nutritionnels et vos coordonnées.</p>
      </div>
      <div className="showcase__frame">
        <div className="rx-doc">
          {/* Top coral gradient bar */}
          <div className="rx-doc__bar" />

          {/* Header with logo + ref */}
          <div className="rx-doc__header">
            <div className="rx-doc__logo">fetchy</div>
            <div className="rx-doc__ref">Réf. RX-2025-00417</div>
          </div>

          {/* Prescriber block */}
          <div className="rx-doc__block">
            <div className="rx-doc__label">Prescripteur</div>
            <div className="rx-doc__value">Clinique vétérinaire</div>
            <div className="rx-doc__value rx-doc__value--muted">Dr. Exemple — DV</div>
          </div>

          {/* Animal block */}
          <div className="rx-doc__block">
            <div className="rx-doc__label">Patient</div>
            <div className="rx-doc__value" style={{ fontWeight: 700 }}>Olaf · Chien castré · 10,0 kg · 5 ans</div>
          </div>

          {/* Narrative */}
          <div className="rx-doc__narrative">
            Besoin énergétique estimé : 534 kcal/j (BEE × 1,6). Ration ménagère équilibrée couvrant les recommandations FEDIAF pour un chien adulte entier en bonne santé.
          </div>

          {/* Ingredient table */}
          <div className="rx-doc__table">
            <div className="rx-doc__thead">
              <span>Ingrédient</span>
              <span>Quantité</span>
            </div>
            <div className="rx-doc__row">
              <span>Courgette, pulpe et peau, crue</span>
              <span>120,0 g</span>
            </div>
            <div className="rx-doc__row">
              <span>B&#339;uf, steak haché 5 % MG</span>
              <span>95,0 g</span>
            </div>
            <div className="rx-doc__row">
              <span>Riz blanc, cuit</span>
              <span>80,0 g</span>
            </div>
            <div className="rx-doc__row">
              <span>Huile de colza</span>
              <span>5,0 g</span>
            </div>
            <div className="rx-doc__row">
              <span>Vit'i5 Bleu</span>
              <span>4,0 g</span>
            </div>
          </div>

          {/* Nutritional summary */}
          <div className="rx-doc__summary">
            <div className="rx-doc__label">Apports clés</div>
            <div className="rx-doc__nutrients">
              <span>Protéines 32 %MS</span>
              <span>Lipides 18 %MS</span>
              <span>Ca 0,9 %MS</span>
              <span>Ca/P 1,4</span>
            </div>
          </div>

          {/* Footer disclaimer */}
          <div className="rx-doc__footer">
            Prescription nutritionnelle — ne se substitue pas à un examen clinique.
          </div>
        </div>
      </div>
      <p className="showcase__caption">
        Chaque prescription inclut : identification du patient, composition de la ration, apports nutritionnels, recommandations et coordonnées du prescripteur.
      </p>
    </div>
  </section>
)

export default Showcase
